module.exports = __webpack_public_path__ + "img/Slice1.55b25797.png";